import { type QuestionTextModel, type RegexValidator } from 'survey-core';

export const getErrorMessageFromValidators = (question: QuestionTextModel) => {
  if (question.validators) {
    for (let i = 0; i < question.validators.length; i++) {
      const validator = question.validators[i];

      if (
        validator.getType() === 'regexvalidator' &&
        question.value &&
        !new RegExp((validator as RegexValidator).regex).test(question.value)
      ) {
        return validator.text || 'Invalid value entered.';
      }
    }
  }

  return null;
};
